import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function InitialScreen() {
  return (
    <Box>
      <Typography sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
        Loading...
      </Typography>
    </Box>
  );
}

export default InitialScreen;
